import { CompanyFeaturesEnum } from './enums.js';
export const EXAMPLE_BULK_EMPLOYEE_UPLOAD_FILE = 'example-bulk-employee-upload-file';
export const features = [
    {
        id: CompanyFeaturesEnum.BASIC_SYSTEM_ACCESS,
        name: 'Basic System Access',
        description: 'Basic access to the system',
        icon: 'user',
        basePrice: 0,
        pricePerValues: [
            {
                label: 'employee',
                value: 'tiered',
            },
        ],
    },
    {
        id: CompanyFeaturesEnum.PREMIUM_DATA_VISUALIZATIONS,
        name: 'Premium Data Visualizations',
        description: 'Advanced Reporting and Charts',
        icon: 'charts',
        basePrice: 1250,
        pricePerValues: [
            {
                label: 'credit',
                value: 2,
            },
        ],
    },
];
